import { Route } from "react-router";

export const renderInfoSidebarRoutes = (Home: React.ComponentType<any>) => {
    const infoPaths = [
        { path: "/about", infoRouteName: "about" },
        { path: "/howtobuybits", infoRouteName: "howtobuybits" },
        { path: "/faq", infoRouteName: "faq" },
        { path: "/journal/:id", infoRouteName: "journal" },
        { path: "/journal", infoRouteName: "journal" },
        { path: "/bitsA-Z", infoRouteName: "bitsAZ" },
        { path: "/news-articles", infoRouteName: "newsArticles" },
        { path: "/testimonial", infoRouteName: "testimonial" },
        { path: "/contact", infoRouteName: "contact" },
        { path: "/privacy-policy", infoRouteName: "privacyPolicy" },
        { path: "/terms", infoRouteName: "terms" },
    ];
    return infoPaths.map((pathName) => (
        <Route
            key={pathName.path}
            path={pathName.path}
            element={<Home infoRouteName={pathName.infoRouteName} />}
        />
    ));
};
